<template>
  <div>
  <div class="content">
    <div class="container">
      <div class="success" style="text-align: center">
        <h1 v-word:layout.registrationSuccess.header />
        <div v-word:layout.registrationSuccess.text />
      </div>
    </div>
  </div>
  <pageFooter />
  </div>
</template>

<script>
import * as mixins from '../mixins';
import footer from '../layout/Footer';
import LanguageSelect from "../components/LanguageSelect";

export default {
  mixins: [mixins.wordedPage],
  components: {pageFooter: footer},
};
</script>



// WEBPACK FOOTER //
// src/pages/RegistrationSuccess.vue